/* global setTimeout */
jQuery(document).ready(function ($) {
  if (!$('body').hasClass('page-template-page-news-stories')) {
    return;
  }

  function resolveSearchFilterQuery() {
    var queries = window.searchAndFilter?.frontend?.queries;
    if (!queries || typeof queries.get !== 'function') {
      return undefined;
    }

    var dataEl = document.getElementById('cmnh-news-filter-data');
    var id = 1;
    if (dataEl && dataEl.textContent) {
      try {
        var cfg = JSON.parse(dataEl.textContent.trim());
        if (cfg && cfg.queryId != null && cfg.queryId !== '') {
          id = cfg.queryId;
        }
      } catch {
        // keep default id
      }
    }

    return (
      queries.get(id) ??
      queries.get(Number(id)) ??
      queries.get(String(id))
    );
  }

  /**
   * Frontend mounts asynchronously; retry so get-results/finish hooks attach reliably.
   */
  function whenSearchFilterQueryReady(callback, attempt) {
    var n = attempt || 0;
    var q = resolveSearchFilterQuery();
    if (q && typeof q.on === 'function') {
      callback(q);
      return;
    }
    if (n >= 80) {
      return;
    }
    setTimeout(function () {
      whenSearchFilterQueryReady(callback, n + 1);
    }, 75);
  }

  function updateCategoryDropdownText() {
    var $selectionContainer = $('.filter-bar .multiselect');

    if (!$selectionContainer.length) return;

    var $selectionItems = $selectionContainer.find(
      '.search-filter-component-combobox__selection-item'
    );
    var count = $selectionItems.length;

    $selectionContainer.find('.selection-count-label').remove();

    $selectionItems.show();

    if (count > 1) {
      $selectionItems.hide();

      $selectionContainer
        .find('input[type="text"]')
        .addClass('has-multiple-selections');

      var $input = $selectionContainer.find(
        '.search-filter-component-combobox__selection'
      );

      if ($input.length) {
        $(
          '<span class="selection-count-label">Selected (' + count + ')</span>'
        ).appendTo($input);
      }
    }
  }

  whenSearchFilterQueryReady(function (query) {
    if (query.__cmnNewsStoriesFinishHook) {
      return;
    }
    query.__cmnNewsStoriesFinishHook = true;

    query.on('get-results/finish', function () {
      setTimeout(function () {
        if (window.cmnRestoreSearchFilterKeywords) {
          window.cmnRestoreSearchFilterKeywords();
        }
        if (query.getAttribute('resultsDynamicUpdate') === 'yes') {
          updateCategoryDropdownText();
        }
        // Let animations.js refresh viewport triggers after dynamic DOM height changes.
        jQuery(document).trigger('contentChanged');
      }, 150);
    });
  });

  $(document).on(
    'click touchend',
    '.multiselect .search-filter-component-combobox__clear-selection > .search-filter-icon, .search-filter-style--control-reset button',
    function () {
      $('.selection-count-label').remove();
      $('.multiselect input[type="text"]').removeClass(
        'has-multiple-selections'
      );
    }
  );

  updateCategoryDropdownText();
});
